/* eslint-disable class-methods-use-this */
import { ACCESS_TOKEN_KEY, TOKEN_TYPE_KEY, SignInData } from '../types';
import { AuthTokenStrategy } from '../AuthTokenStrategy';
import { HEADERS, RequestHeaders } from '../../Request/RequestHeaders';

export default class LocalStorageStrategy implements AuthTokenStrategy {
  public getAuthenticationHeader(): RequestHeaders {
    const authHeader = this.getAuthToken();
    if (!authHeader) {
      return {};
    }

    return {
      [HEADERS.AUTHORIZATION]: authHeader,
    };
  }

  public getAuthenticationToken(): string | undefined {
    return this.getAuthToken();
  }

  public isLoggedIn() {
    return this.getAuthToken() !== undefined;
  }

  public signIn(payload: SignInData, forceOverwrite?: boolean) {
    // Prevent overwritting a logged in user
    if (this.isLoggedIn() && !forceOverwrite) {
      throw new Error('There is already a user logged in');
    }
    // Update sign in data storage
    const { accessToken, tokenType } = payload;
    this.storeAuthToken(accessToken, tokenType);
  }

  public signOut() {
    this.destroyToken();
    window.location.href = `${window.location.origin}/login${window.location.search}`;
  }

  /**
   * Persists the user's authentication info, that can be later used
   * to build the authentication header for the api requests.
   */
  private storeAuthToken(accessToken: string, tokenType: string) {
    try {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      localStorage.setItem(TOKEN_TYPE_KEY, tokenType);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Attempts to obtain the user authentication info from the available
   * storage method (localStorage).
   */
  private getAuthToken(): string | undefined {
    try {
      const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
      const tokenType = localStorage.getItem(TOKEN_TYPE_KEY);
      return accessToken ? `${tokenType} ${accessToken}` : undefined;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  /**
   * Deletes the authentication info from localStorage
   */
  private destroyToken() {
    try {
      localStorage.removeItem(ACCESS_TOKEN_KEY);
      localStorage.removeItem(TOKEN_TYPE_KEY);
    } catch (error) {
      console.log(error);
    }
  }
}
